// extracted by mini-css-extract-plugin
module.exports = {"selectWidget":"admin-portal__SelectWidget__selectWidget","error":"admin-portal__SelectWidget__error"};